import { RootState } from "../rootReducer";
import { DealFundraisingCapacity } from "./dealCapacity.types";

export const getDealCapacityMapSelector = (
  state: RootState
): Record<string, DealFundraisingCapacity> => state.dealCapacity.byDealId;

// Plain O(1) map lookup — intentionally not memoised. Many cards call this with
// different dealIds; a single shared createSelector instance would thrash its
// one-slot cache.
export const getDealCapacitySelector = (
  state: RootState,
  dealId: string
): DealFundraisingCapacity | undefined => state.dealCapacity.byDealId[dealId];

export const getIsLoadingDealCapacitySelector = (state: RootState): boolean =>
  state.dealCapacity.loading;
